<template>
<div>
	<nav class="navbar">
		<div>
			<div class="btn btn-menu-toggle" @click="opened=!opened"><i class="fa fa-bars"></i></div>
			<img src="@/assets/logo.png" alt="" class="logo">
		</div>
	</nav>

	<div class="nav-spacer"></div>

	<div class="sidebar-wrapper" :class="{'opened':opened}">

		<div class="head">
			<b-dropdown block menu-class="w-100">
				<template v-slot:button-content class="dropdown-user">
					<div class="avatar" :style="{backgroundImage: `url('${ require('@/assets/img/no-avatar-image.gif') }')` }" ></div>
					{{loggedUser.fullname}}
				</template>
				<!-- <b-dropdown-item href="#">An item</b-dropdown-item> -->
				<router-link tag="b-dropdown-item" to="/logout">Salir</router-link>
			</b-dropdown>
			
		</div>

		<h3>Generales</h3>
		<div class="list-group list-group-flush mt-2">	
			
			<router-link to="/" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-dashboard"></i></div>
				<span>Dashboard</span>
			</router-link>

			<router-link to="/cars" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-car"></i></div>
				<span>Vehículos</span>
			</router-link>
			
			<router-link to="/damages" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-car"></i></div>
				<span>Daños</span>
			</router-link>
			
			<router-link to="/controls" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-car"></i></div>
				<span>Controles</span>
			</router-link>

			<router-link to="/transfers" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-arrows"></i></div>
				<span>Traslados</span>
			</router-link>

			
			<router-link to="/map" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-map"></i></div>
				<span>Mapa</span>
			</router-link>

			<router-link to="/clients" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-star"></i></div>
				<span>Clientes</span>
			</router-link>
			
			<router-link to="/users" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-users"></i></div>
				<span>Usuarios</span>
			</router-link>
			
			<router-link to="/employees" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-users"></i></div>
				<span>Funcionarios</span>
			</router-link>

			<router-link to="/brands" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-users"></i></div>
				<span>Marcas / Modelos</span>
			</router-link>
			
			<router-link to="/settings" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="fa fa-cog"></i></div>
				<span>Configuraciones</span>
			</router-link>
		</div>

	</div>
	
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: "Navbar",
	data() {
		return {
			opened: false, 
		};
	},
	computed:{
		...mapGetters(['loggedUser'])
	},
	
};
</script>
<style >
.navbar{
	padding: 0px 8px;
	width: calc(100% - 200px );
	height: 64px;
	top: 0px;
	left:200px;
	background-color: #fff;
	z-index: 150;
	position: fixed;
}
.navbar .btn-menu-toggle{
	font-size: 18px;
	color: #000;
	display: none;
}

@media (max-width: 991px) {
	.navbar{
		width: 100%;
		left: 0px;
	}
	.navbar .btn-menu-toggle{
		display: inline-block;
	}
}

.nav-spacer{
	width:100%;
	height: 64px;
}
.navbar .logo{
	max-width: 200px;

}
.navbar .nav-item .nav-link{
	min-height: 60px;
	line-height: 60px;
	padding: 0px;
	margin: 0px 14px;
	color: #333;
}
.navbar .icon{
	position:relative;
	display: inline;
}
.navbar .icon .number {
	position: absolute;
	top: -10px;
	background-color: #EB0000;
	color: #fff;
	border-radius: 100px;
	width: 13px;
	height: 13px;
	font-size: 11px;
	line-height: 1.2em;
	right: -6px;
	text-align: center;
}



.sidebar-wrapper {
	width: 200px;
	height: 100%;
	overflow: hidden;
	top: 0px;
	left: 0;
	z-index: 100;
	position: fixed;
	color: #000;
	background-color: #fff;
	transition: all 0.3s ease-in-out;
	-webkit-box-shadow: none;
		-moz-box-shadow: none;
		box-shadow: none;
}

@media (max-width: 991px) {
	.sidebar-wrapper {
		top: 64px;
		height: calc( 100% - 64px);
		left: -220px;
		-webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
		-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
		box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
		
	}
}
	.sidebar-wrapper.opened {
		left: 0px !important;
	}


	.sidebar-wrapper .head {
		height: 64px;
		display: flex;	
		font-size: 14px;
		font-weight: normal;
		line-height: 20px;
	}
	

	.sidebar-wrapper .list-group {
		width: 100%;
		background-color: inherit;
	}
	.sidebar-wrapper .list-group a{
		background-color: transparent;
		color: inherit;
		padding: 0px;
		height: 44px;
		line-height: 44px;
		border: none;
	}
	.sidebar-wrapper .list-group a:hover{
		
	}

	.sidebar-wrapper .list-group a .icon{
		width: 54px;
		text-align: center;
		display: inline-block;
	}
	.sidebar-wrapper .list-group a .icon i{
		color: inherit;
		font-size: 12px;
	}
	.sidebar-wrapper .list-group a span{
		display: inline-block;
		font-size: 13px;
		-webkit-transition: all .15s ease-in-out;
		-moz-transition: all .15s ease-in-out;
		-o-transition: all .15s ease-in-out;
		transition: all .15s ease-in-out;
				
	}

	.sidebar-wrapper:hover .list-group a span{
		opacity: 1;
		
	}
	.sidebar-wrapper h3{
		font-size: 12px;
		text-transform: uppercase;
		padding: 20px 0px 0px 12px;
		margin: 0px;
		opacity: 0.5;
	}


.sidebar-wrapper .dropdown{
	width: 100%;
}
.sidebar-wrapper .dropdown .btn{
	height:64px;
	background-color:#fff;
	color: #000;
	display: flex;
	align-items: center;
	border:none;
	font-size: 12px;
}
.sidebar-wrapper .avatar{
	width: 32px;
	height: 32px;
	background-color:#f2f2f2;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	margin-right:8px;
}

</style>
